
  document.querySelectorAll('.product-card-slider:not(.splide-initialized)').forEach(function (slider) {
    var splide = new Splide(slider, {
      type: 'loop',
      perPage: 1,
      arrows: true,
      pagination: true,
      autoplay: false,
    });

    splide.mount();
    slider.classList.add('splide-initialized');

    slider.addEventListener('click', function (e) {
      if (e.target.closest('.splide__arrow') || e.target.closest('.splide__pagination')) {
        e.stopPropagation();
        e.preventDefault();
      }
    });
  });

// ===== Splide resilient init for Prestige (works for removable-facet) =====
(function () {
  const INIT_CLASS = 'splide-initialized';
  const SPLIDE_SELECTOR = '.product-card-slider';

  function mountSplideOn(el) {
    try {
      if (!window.Splide) return; // Splide not loaded yet
      if (el.classList.contains(INIT_CLASS)) return;

      // Destroy any old instance stored on the element (safe-rerun)
      if (el._splideInstance) {
        try { el._splideInstance.destroy(); } catch(e) {}
        el._splideInstance = null;
        el.classList.remove(INIT_CLASS);
      }

      const inst = new Splide(el, {
        type: 'loop',
        perPage: 1,
        arrows: true,
        pagination: true,
        autoplay: false,
        // tweak options as needed
      });
      inst.mount();
      el._splideInstance = inst;
      el.classList.add(INIT_CLASS);
        inst.addEventListener('click', function (e) {
      if (e.target.closest('.splide__arrow') || e.target.closest('.splide__pagination')) {
        e.stopPropagation();
        e.preventDefault();
      }
    });
    } catch (err) {
      // fail silently but keep a hint in console for debugging
      console.warn('Splide init error', err, el);
    }
  }

  function initAllSliders(root = document) {
    if (!window.Splide) return;
    root.querySelectorAll(SPLIDE_SELECTOR).forEach(mountSplideOn);
  }

  // 1) Init on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => initAllSliders(document));

  // 2) Re-init after Prestige's facet:update (this covers the normal AJAX flow)
  document.addEventListener('facet:update', () => {
    // Ensure we run after Prestige's replaceChildren() — give browser a paint + tiny delay
    requestAnimationFrame(() => setTimeout(() => initAllSliders(document), 40));
  });

  // 3) MutationObserver on the whole document — catches removable-facet, drawer close, any insertion
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // check added nodes only (cheap)
      if (!m.addedNodes || m.addedNodes.length === 0) continue;
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        // if the added node itself is a Splide root
        if (node.matches && node.matches(SPLIDE_SELECTOR)) {
          mountSplideOn(node);
        }
        // or contains Splide roots
        if (node.querySelectorAll) {
          const found = node.querySelectorAll(SPLIDE_SELECTOR);
          if (found && found.length) found.forEach(mountSplideOn);
        }
      });
    }
  });

  mo.observe(document.documentElement || document.body, { childList: true, subtree: true });

  // Optional: try a last-ditch init if Splide loads later
  const tryLater = setInterval(() => {
    if (window.Splide) {
      initAllSliders(document);
      clearInterval(tryLater);
    }
  }, 300);
})();
